import { Stack, styled } from "@mui/material";
import PropTypes from "prop-types";
import breakpoints from "../../constants/breakpoints.js";
import {
  DESKTOP_HEADER_HEIGHT,
  IGNORE_MAX_WIDTH,
  MOBILE_HEADER_HEIGHT,
} from "../../constants/styles.js";
import useDocumentTitle from "../../hooks/useDocumentTitle.js";

const StyledStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  minHeight: "100%",
  position: "relative",
  [`> *:not(${IGNORE_MAX_WIDTH})`]: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "inherit",
    [theme.breakpoints.down("xs")]: {
      maxWidth: breakpoints.sm,
    },
    [theme.breakpoints.up("md")]: {
      maxWidth: breakpoints.xxl,
    },
  },
  [theme.breakpoints.up("xs")]: {
    padding: theme.spacing(0, 3, 4),
    marginBlockStart: MOBILE_HEADER_HEIGHT,
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(0, 2.5, 6.25),
  },
  [theme.breakpoints.up("lg")]: {
    marginBlockStart: DESKTOP_HEADER_HEIGHT,
  },
  [theme.breakpoints.up("xxl")]: {
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const Page = ({ children, title = "", ...otherProps }) => {
  useDocumentTitle(title);

  return (
    <StyledStack
      width="100%"
      component="main"
      flex={1}
      minHeight="100%"
      alignItems="center"
      {...otherProps}
    >
      {children}
    </StyledStack>
  );
};

Page.propTypes = {
  title: PropTypes.string,
};

export default Page;
